import { Authenticated } from "@refinedev/core";
import { CatchAllNavigate } from "@refinedev/react-router-v6";
import { Outlet, Route } from "react-router-dom";
import { SettingsPage } from "../pages/profile";
import { ResponsiveLayout } from "../components/layout/MobileLayout";

/**
 * Personal settings — "Mon compte".
 *
 * Deliberately gated on authentication only, with no `<CanAccess>` resource.
 * `/settings` used to be declared twice: once in customerRoutes behind
 * `resource="account-home"` and once in adminRoutes. CustomerRoutes renders
 * first, so admins were reaching their own account page through the *customer*
 * guard — which passes today only because `accessControlProvider` is allow-all
 * for admins. Every authenticated user owns an account page, so it belongs in
 * neither role's route table.
 */
export const PersonalRoutes = (
  <Route
    element={
      <Authenticated
        key="authenticated-personal"
        fallback={<CatchAllNavigate to="/login" />}
      >
        <ResponsiveLayout>
          <Outlet />
        </ResponsiveLayout>
      </Authenticated>
    }
  >
    <Route path="settings" element={<SettingsPage />} />
  </Route>
);
